import React, { FC } from 'react';
import SelectorBody from './components/selector-body.component';
import SelectorHeader from './components/selector-header.component';
import { Container } from '@mui/material';
import { Box } from '@mui/system';

const LoginSelectorPage: FC = () => {
  return (
    <Container
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '24px',
        height: '100%',
        maxWidth: '400px',
        paddingTop: '36px',
        paddingBottom: '36px',
        background: '#ffffff',
      }}
      maxWidth={false}
      className='container'
    >
      <Box
        sx={{
          flexDirection: 'column',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 298,
        }}
        id='login-selector-page'
      >
        <SelectorHeader />
        <SelectorBody />
      </Box>
    </Container>
  );
};

export default LoginSelectorPage;
